export default {"src":"/_next/static/media/anything-else.faf18749.svg","height":115,"width":116,"blurWidth":0,"blurHeight":0};